module.exports = __webpack_public_path__ + "img/md_point-s.e2a0948b.png";